import { TurnInto } from 'types'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { Group } from './Types'

export const GROUPS: Array<Group> = [
  {
    name: 'Popular',
    channels: [
      ChannelType.BlogPost,
      'instagram-portrait-post',
      ChannelType.InstagramReel,
      'instagram-square-post',
      'linkedin-post',
      GenerationType.LinkedInPlanning,
      ChannelType.FacebookPost,
      ChannelType.FacebookAds,
      ChannelType.TikTokScript,
    ],
  },
  {
    name: 'Tools',
    channels: [
      GenerationType.InstagramPlanning,
      GenerationType.SEOPlanning,
      GenerationType.LinkedInPlanning,
      GenerationType.FacebookPlanning,
      GenerationType.TwitterPlanning,
      GenerationType.Brainstorm,
      GenerationType.Campaign,
      GenerationType.ContentPlan,
      TurnInto.DocsIntoContent,
      TurnInto.AudioIntoContent,
      TurnInto.WebsitesIntoContent,
      TurnInto.VideoIntoContent,
    ],
  },
  {
    name: 'Social media',
    channels: [
      ChannelType.InstagramPosts,
      'instagram-portrait-post',
      'instagram-square-post',
      'instagram-landscape-post',
      'instagram-story',
      'facebook-post',
      'facebook-portrait-post',
      'facebook-cover',
      'facebook-profile-picture',
      ChannelType.FacebookPost,
      'linkedin-post',
      'linkedin-portrait-post',
      'linkedin-banner',
      'linkedin-profile-picture',
      ChannelType.LinkedInPosts,
      'twitter-post',
      'twitter-portrait-post',
      'twitter-profile-picture',
      'twitter-cover-image',
      ChannelType.Tweets,
      ChannelType.TweetThread,
      'whatsapp-sticker',
      'square-post',
      'portrait-post',
      'landscape-post',
      'pinterest',
    ],
  },
  {
    name: 'Blog/SEO',
    channels: [
      ChannelType.BlogPost,
      ChannelType.BlogIdeas,
      GenerationType.Outline,
      GenerationType.ContentBrief,
      ChannelType.CaseStudy,
      ChannelType.PressRelease,
    ],
  },
  {
    name: 'Marketplaces',
    channels: [
      'facebook-marketplace',
      'ebay',
      'poshmark',
      'depop',
      'mercari',
      'mercadolibre',
      'shopee',
      'lazada',
      'etsy',
      'vinted',
      'amazon',
      'shopify-square',
      ChannelType.ProductLaunchWebsite,
      ChannelType.ProductLaunchShopify,
      ChannelType.ProductLaunchAmazon,
      ChannelType.ProductLaunchEtsy,
      ChannelType.ProductLaunchGoogle,
    ],
  },
  {
    name: 'Video',
    channels: [
      'instagram-reel',
      ChannelType.InstagramReel,
      'tik-tok-post',
      'tik-tok-thumbnail',
      ChannelType.TikTokScript,
      ChannelType.YoutubeScript,
      'youtube-short',
      'youtube-channel-art',
      'youtube-profile-picture',
    ],
  },
  {
    name: 'Emails',
    channels: [
      ChannelType.Newsletter,
      ChannelType.NewsletterIdeas,
      ChannelType.PromotionalEmailSequence,
      ChannelType.NurtureEmailSequence,
      ChannelType.WelcomeSeries,
      ChannelType.DidntSignUp,
      ChannelType.AbandonedCart,
      ChannelType.LostCustomer,
      ChannelType.WarmOutboundEmailSequence,
      ChannelType.ColdOutboundEmailSequence,
      ChannelType.SMSMessages,
    ],
  },
  {
    name: 'Ads',
    channels: [
      ChannelType.FacebookAds,
      ChannelType.GoogleAds,
      ChannelType.LinkedInAds,
      ChannelType.YoutubeAds,
      ChannelType.BingAds,
      ChannelType.TikTokAds,
      ChannelType.AmazonAds,
      ChannelType.PinterestAds,
    ],
  },
  {
    name: 'Website',
    channels: [
      ChannelType.LandingPage,
      ChannelType.AboutUs,
      ChannelType.Pricing,
      ChannelType.FAQs,
      ChannelType.Mission,
      ChannelType.Impact,
    ],
  },
  {
    name: 'Sales',
    channels: [
      ChannelType.OnePager,
      ChannelType.ProductDemo,
      ChannelType.PreCallChecklist,
      ChannelType.CallScript,
      ChannelType.Research,
      ChannelType.BattleCard,
      ChannelType.Testimonial,
    ],
  },
  {
    name: 'Customer Service',
    channels: [
      ChannelType.ReplyTemplates,
      ChannelType.HelpDocs,
      ChannelType.ReturnPolicy,
      ChannelType.ShippingPolicy,
      ChannelType.CareInstructions,
      ChannelType.BillingAndPayments,
      ChannelType.PaymentConfirmation,
    ],
  },
  {
    name: 'Recruiting',
    channels: [ChannelType.JobDescription, ChannelType.CandidateNurtureSequence],
  },
]
